import './EulaDailog.scss'
import { Modal, Button } from 'react-bootstrap'
import { Sanitized } from '../EULA/Sanitized'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { getEulaContent } from '../Services/WidgetService'
import CA from '../assets/CA.png'
import MX from '../assets/MX.png'
import US from '../assets/US.png'
import { usePostPayload } from '../utils/PostPayloadContext'
import expand from '../assets/expand.png'
import { LanguageKey } from '../interfaces'
import NiceModal, { useModal } from '@ebay/nice-modal-react'

const EulaDailog = NiceModal.create(() => {
  const modal = useModal()
  const { setLoader } = usePostPayload()
  const [conditions, setConditions] = useState<string>('')
  const [cssDisplay, setCssDisplay] = useState('none')

  const languages = useMemo(
    () => [
      {
        id: 1,
        name: 'ENGLISH',
        key: LanguageKey.ENGLISH,
        image: US,
        url: 'https://myplace-eula-dxp-dr.s3.amazonaws.com/qa-eula/MyPlace+EULA+2025_English.html',
      },
      {
        id: 2,
        name: 'SPANISH',
        key: LanguageKey.SPANISH,
        image: MX,
        url: 'https://myplace-eula-dxp-dr.s3.amazonaws.com/qa-eula/MyPlace+EULA+2025_Spanish.html',
      },
      {
        id: 3,
        name: 'FRENCH',
        key: LanguageKey.FRENCH,
        image: CA,
        url: 'https://myplace-eula-dxp-dr.s3.amazonaws.com/qa-eula/MyPlace+EULA+2025_FrenchCA.html',
      },
    ],
    []
  )

  const [selectedLang, setSelectedLang] = useState(languages[0])

  const disclaimerText: Record<LanguageKey, string> = {
    [LanguageKey.ENGLISH]:
      'The English version of this document is the legally binding version. Translations in Spanish, French, or any other language are provided solely for reference purposes.',
    [LanguageKey.SPANISH]:
      'La versión en inglés de este documento es la versión legalmente vinculante. Las traducciones al español, francés o cualquier otro idioma se proporcionan únicamente con fines de referencia.',
    [LanguageKey.FRENCH]:
      'La version anglaise de ce document est la version juridiquement contraignante. Les traductions en espagnol, en français ou dans toute autre langue sont fournies uniquement à titre de référence.',
  }

  const languageItem = useMemo(() => {
    return (
      languages.find((item) => item.name === selectedLang.name)?.url ||
      languages[0].url
    )
  }, [languages, selectedLang.name])

  const fetchEulaContent = useCallback(async () => {
    setLoader(true)
    try {
      const eulaContent = await getEulaContent(languageItem)
      setConditions(eulaContent)
    } catch (_error) {
      /* empty */
    } finally {
      setLoader(false)
    }
  }, [languageItem, setLoader])

  useEffect(() => {
    fetchEulaContent()
  }, [fetchEulaContent])

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const selectListItem = (sOption: any) => {
    setCssDisplay('none')
    setSelectedLang(sOption)
  }

  const showDropdown = () => {
    setCssDisplay(cssDisplay === 'none' ? 'block' : 'none')
  }

  return (
    <Modal
      show={modal.visible}
      onHide={() => modal.hide()}
      centered
      dialogClassName="eula-modal"
    >
      <Modal.Header closeButton>
        <div className="header-flex">
          <Modal.Title>End User License Agreement</Modal.Title>
          <div className="DropDownContainer">
            <button onClick={showDropdown}>
              <img className="selected-image-option" src={selectedLang.image} />{' '}
              {selectedLang.name} <img className="expand-img" src={expand} />
            </button>
            <div className="lang-container">
              <ul
                className="lang-option-container"
                style={{ display: cssDisplay }}
              >
                {languages.map((lang) => (
                  <li
                    className="lang-li-options"
                    onClick={() => selectListItem(lang)}
                    key={lang.id}
                  >
                    <img
                      className="lang-image-option"
                      src={lang.image}
                      height="30"
                      width="30"
                      alt="flagpic"
                    />
                    {lang.name}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body className="eula-body">
        <Sanitized html={conditions}></Sanitized>
      </Modal.Body>

      <Modal.Footer className="eula-footer">
        <div className="language-disclaimer">{disclaimerText[selectedLang.key]}</div>
        <Button className="log_btn_signIn" onClick={() => modal.hide()}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
})

export default EulaDailog
